<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" class="pl-5">
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(false)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(true)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.saveAndExit') }}
                </v-btn>
                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col></v-row
        ><v-row
            style="
                margin-top: 3px;
                margin-bottom: 0px;
                scroll-margin: 0px;
                height: 81vh;
                overflow-y: scroll;
                overflow-x: hidden;
            "
        >
            <v-row>
                <v-col cols="6" v-if="$myStore.state.user.user_role_id != 3">
                    <v-card flat>
                        <v-card-text>
                            <v-row dense>
                                <v-col cols="6">
                                    <Dropdown
                                        :readonly="!inEditMode"
                                        v-model="template_id"
                                        :ajax="true"
                                        :data="'wage-templates'"
                                        :label="$t('fields.loadFromTemplate')"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="2">
                                    <v-btn
                                        class="ml-2 mr-2 mt-1"
                                        color="primary"
                                        @click="loadFromTemplate()"
                                        :disabled="template_id == null"
                                    >
                                        <v-icon class="mr-2" small>fas fa-paste</v-icon>{{ $t('buttons.load') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card flat>
                        <v-card-text>
                            <v-row dense wrap>
                                <v-col cols="10" v-if="$myStore.state.user.user_role_id != 3">
                                    <Dropdown
                                        :readonly="!inEditMode"
                                        v-model="wageTemplate.currency_id"
                                        :ajax="true"
                                        :data="'currencies-with-exchange'"
                                        :errorBorder="!wageTemplateValidation.currency_id"
                                        :label="'* ' + $t('fields.currency')"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="10" v-else>
                                    <Dropdown
                                        :readonly="true"
                                        v-model="wageTemplate.currency_id"
                                        :ajax="true"
                                        :data="'currencies-with-exchange'"
                                        :errorBorder="!wageTemplateValidation.currency_id"
                                        :label="'* ' + $t('fields.currency')"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="2"> </v-col>
                                <v-col cols="12" class="pt-0" v-if="$myStore.state.user.user_role_id != 3">
                                    <CheckBox
                                        :readonly="!inEditMode"
                                        v-model="wageTemplate.salary_through_azara"
                                        :label="$t('fields.seafarerSalaryGoesThroughAzara')"
                                    ></CheckBox>
                                </v-col>
                                <v-col cols="12" class="pt-0" v-else>
                                    <CheckBox
                                        :readonly="true"
                                        v-model="wageTemplate.salary_through_azara"
                                        :label="$t('fields.seafarerSalaryGoesThroughAzara')"
                                    ></CheckBox>
                                </v-col>
                                <v-col cols="3" class="pt-0" v-if="$myStore.state.user.user_role_id != 3">
                                    <CheckBox
                                        :readonly="!inEditMode"
                                        v-model="wageTemplate.apply_agency_fee"
                                        :label="$t('fields.applyAgencyFee')"
                                    ></CheckBox>
                                </v-col>
                                <v-col cols="3" class="pt-0" v-else>
                                    <CheckBox
                                        :readonly="true"
                                        v-model="wageTemplate.apply_agency_fee"
                                        :label="$t('fields.applyAgencyFee')"
                                    ></CheckBox>
                                </v-col>
                                <v-col cols="5" v-if="$myStore.state.user.user_role_id != 3">
                                    <Dropdown
                                        v-if="inEditMode"
                                        :readonly="!feeType"
                                        v-model="wageTemplate.fee_type_id"
                                        :ajax="true"
                                        :data="'fee-types'"
                                        :errorBorder="!wageTemplateValidation.fee_type_id"
                                        :label="$t('fields.feeType')"
                                    ></Dropdown>
                                    <Dropdown
                                        v-else
                                        :readonly="true"
                                        v-model="wageTemplate.fee_type_id"
                                        :ajax="true"
                                        :data="'fee-types'"
                                        :errorBorder="!wageTemplateValidation.fee_type_id"
                                        :label="$t('fields.feeType')"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="5" v-else>
                                    <Dropdown
                                        :readonly="true"
                                        v-model="wageTemplate.fee_type_id"
                                        :ajax="true"
                                        :data="'fee-types'"
                                        :errorBorder="!wageTemplateValidation.fee_type_id"
                                        :label="$t('fields.feeType')"
                                    ></Dropdown>
                                </v-col>
                                <v-col cols="2" v-if="$myStore.state.user.user_role_id">
                                    <CurrencyField
                                        v-if="wageTemplate.fee_type_id == 1"
                                        :max="100"
                                        :min="0.0"
                                        :readonly="!agencyFeePercentage"
                                        v-model="wageTemplate.agency_fee_percentage"
                                        :errorBorder="!wageTemplateValidation.agency_fee_percentage"
                                        :key="componentKey"
                                        :label="$t('fields.percentage')"
                                    ></CurrencyField>
                                </v-col>
                                <v-col cols="2" v-else>
                                    <CurrencyField
                                        v-if="wageTemplate.fee_type_id == 1"
                                        :max="100"
                                        :min="0.0"
                                        :readonly="true"
                                        v-model="wageTemplate.agency_fee_percentage"
                                        :errorBorder="!wageTemplateValidation.agency_fee_percentage"
                                        :key="componentKey"
                                        :label="$t('fields.feeType')"
                                    ></CurrencyField>
                                </v-col>
                                <v-col cols="2"></v-col>
                                <v-col cols="12" class="pt-0" v-if="$myStore.state.user.user_role_id != 3">
                                    <CheckBox
                                        v-if="inEditMode"
                                        :readonly="
                                            !(
                                                wageTemplate.salary_through_azara &&
                                                wageTemplate.apply_agency_fee &&
                                                wageTemplate.fee_type_id == 3
                                            )
                                        "
                                        v-model="wageTemplate.merge_seafarer_salary_and_agency_fee_on_invoice"
                                        :label="$t('fields.mergeSeafarerSalaryAndFixedAgencyFeeOnInvoice')"
                                    ></CheckBox>
                                    <CheckBox
                                        v-else
                                        :readonly="true"
                                        v-model="wageTemplate.merge_seafarer_salary_and_agency_fee_on_invoice"
                                        :label="$t('fields.mergeSeafarerSalaryAndFixedAgencyFeeOnInvoice')"
                                    ></CheckBox>
                                </v-col>
                                <v-col cols="12" class="pt-0" v-else>
                                    <CheckBox
                                        :readonly="true"
                                        v-model="wageTemplate.merge_seafarer_salary_and_agency_fee_on_invoice"
                                        :label="$t('fields.mergeSeafarerSalaryAndFixedAgencyFeeOnInvoice')"
                                    ></CheckBox>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="6">
                    <v-col cols="12" class="mb-2 ml-0 pl-0 text-h6">{{ $t('labels.applyAgencyFeeOn') }}</v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id != 3">
                        <CheckBox
                            :readonly="!inEditMode"
                            v-model="wageTemplate.full_day_fee"
                            :label="$t('fields.fullDay')"
                            :key="componentKey"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id == 3">
                        <CheckBox
                            :readonly="true"
                            v-model="wageTemplate.full_day_fee"
                            :label="$t('fields.fullDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id != 3">
                        <CheckBox
                            :readonly="!inEditMode"
                            v-model="wageTemplate.sick_day_fee"
                            :label="$t('fields.sickDay')"
                            :key="componentKey"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id == 3">
                        <CheckBox
                            :readonly="true"
                            v-model="wageTemplate.sick_day_fee"
                            :label="$t('fields.sickDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id != 3">
                        <CheckBox
                            :readonly="!inEditMode"
                            v-model="wageTemplate.travel_day_fee"
                            :label="$t('fields.travelDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id == 3">
                        <CheckBox
                            :readonly="true"
                            v-model="wageTemplate.travel_day_fee"
                            :label="$t('fields.travelDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id != 3">
                        <CheckBox
                            :readonly="!inEditMode"
                            v-model="wageTemplate.training_day_fee"
                            :label="$t('fields.trainingDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id == 3">
                        <CheckBox
                            :readonly="true"
                            v-model="wageTemplate.training_day_fee"
                            :label="$t('fields.trainingDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id != 3">
                        <CheckBox
                            :readonly="!inEditMode"
                            v-model="wageTemplate.quarantine_day_fee"
                            :label="$t('fields.quarantineDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id == 3">
                        <CheckBox
                            :readonly="true"
                            v-model="wageTemplate.quarantine_day_fee"
                            :label="$t('fields.quarantineDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id != 3">
                        <CheckBox
                            :readonly="!inEditMode"
                            v-model="wageTemplate.standby_day_fee"
                            :label="$t('fields.standbyDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id == 3">
                        <CheckBox
                            :readonly="true"
                            v-model="wageTemplate.standby_day_fee"
                            :label="$t('fields.standbyDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id != 3">
                        <CheckBox
                            :readonly="!inEditMode"
                            v-model="wageTemplate.other_day_fee"
                            :label="$t('fields.otherDay')"
                        ></CheckBox>
                    </v-col>
                    <v-col class="pa-0" v-if="$myStore.state.user.user_role_id == 3">
                        <CheckBox
                            :readonly="true"
                            v-model="wageTemplate.other_day_fee"
                            :label="$t('fields.otherDay')"
                        ></CheckBox>
                    </v-col>
                </v-col>

                <v-col cols="12">
                    <v-card flat>
                        <v-card-text>
                            <v-row>
                                <v-col>
                                    <v-data-table
                                        :headers="itemHeaders"
                                        :items="items"
                                        fixed-header
                                        dense
                                        class="row-item"
                                        :items-per-page="-1"
                                        :hide-default-footer="true"
                                        :height="400"
                                        :no-data-text="$t('labels.noData')"
                                    >
                                        <template v-slot:body.prepend>
                                            <td style="width: 10%">
                                                <v-row dense>
                                                    <v-col>
                                                        <Dropdown
                                                            :readonly="!inEditMode"
                                                            v-model="item.rank_id"
                                                            :errorBorder="!itemValidation.rank_id"
                                                            :ajax="true"
                                                            :data="'ranks-abbreviation'"
                                                        ></Dropdown>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td style="width: 10%">
                                                <v-row dense>
                                                    <v-col>
                                                        <Dropdown
                                                            :readonly="!inEditMode"
                                                            v-model="item.seniority"
                                                            :errorBorder="!itemValidation.seniority"
                                                            :ajax="false"
                                                            :data="seniorityList"
                                                        ></Dropdown>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td style="width: 10%">
                                                <v-row dense>
                                                    <v-col>
                                                        <CurrencyField
                                                            :min="0"
                                                            :max="10000"
                                                            :readonly="!inEditMode"
                                                            v-model="item.full"
                                                            :key="componentKey"
                                                        ></CurrencyField>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td style="width: 10%">
                                                <v-row dense>
                                                    <v-col>
                                                        <CurrencyField
                                                            :min="0"
                                                            :max="10000"
                                                            :readonly="!inEditMode"
                                                            v-model="item.sick"
                                                            :key="componentKey"
                                                        ></CurrencyField>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td style="width: 10%">
                                                <v-row dense>
                                                    <v-col>
                                                        <CurrencyField
                                                            :min="0"
                                                            :max="10000"
                                                            :readonly="!inEditMode"
                                                            v-model="item.travel"
                                                            :key="componentKey"
                                                        ></CurrencyField>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td style="width: 10%">
                                                <v-row dense>
                                                    <v-col>
                                                        <CurrencyField
                                                            :min="0"
                                                            :max="10000"
                                                            :readonly="!inEditMode"
                                                            v-model="item.training"
                                                            :key="componentKey"
                                                        ></CurrencyField>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td style="width: 10%">
                                                <v-row dense>
                                                    <v-col>
                                                        <CurrencyField
                                                            :min="0"
                                                            :max="10000"
                                                            :readonly="!inEditMode"
                                                            v-model="item.quarantine"
                                                            :key="componentKey"
                                                        ></CurrencyField>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td style="width: 10%">
                                                <v-row dense>
                                                    <v-col>
                                                        <CurrencyField
                                                            :min="0"
                                                            :max="10000"
                                                            :readonly="!inEditMode"
                                                            v-model="item.standby"
                                                            :key="componentKey"
                                                        ></CurrencyField>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td style="width: 10%">
                                                <v-row dense>
                                                    <v-col>
                                                        <CurrencyField
                                                            :min="0"
                                                            :max="10000"
                                                            :readonly="!inEditMode"
                                                            v-model="item.other"
                                                            :key="componentKey"
                                                        ></CurrencyField>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td style="width: 10%">
                                                <v-row dense>
                                                    <v-col>
                                                        <CurrencyField
                                                            v-if="wageTemplate.fee_type_id != 1"
                                                            :min="0"
                                                            :max="10000"
                                                            :readonly="!fixedFee"
                                                            v-model="item.fixed"
                                                            :key="componentKey"
                                                        ></CurrencyField>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td style="width: 5%" v-if="inEditMode">
                                                <v-row dense>
                                                    <v-col>
                                                        <v-btn
                                                            class="ml-2 mr-2"
                                                            color="primary"
                                                            @click="saveItemClick()"
                                                        >
                                                            <v-icon small>fa-plus</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </td>
                                            <td v-else style="width: 5%"></td>
                                        </template>
                                        <template v-slot:item="row">
                                            <tr>
                                                <td>
                                                    {{ row.item.rank.abbreviation }}
                                                </td>
                                                <td>
                                                    {{ row.item.seniority }}
                                                </td>
                                                <td>
                                                    {{ row.item.full }}
                                                </td>
                                                <td>
                                                    {{ row.item.sick }}
                                                </td>
                                                <td>
                                                    {{ row.item.travel }}
                                                </td>
                                                <td>
                                                    {{ row.item.training }}
                                                </td>
                                                <td>
                                                    {{ row.item.quarantine }}
                                                </td>
                                                <td>
                                                    {{ row.item.standby }}
                                                </td>
                                                <td>
                                                    {{ row.item.other }}
                                                </td>
                                                <td>
                                                    {{ row.item.fixed }}
                                                </td>
                                                <td v-if="inEditMode">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{on, attrs}">
                                                            <v-btn
                                                                icon
                                                                v-bind="attrs"
                                                                @click="edit(row.item)"
                                                                v-on="on"
                                                            >
                                                                <v-icon small>fas fa-edit</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>{{ $t('tooltips.edit') }}</span>
                                                    </v-tooltip>
                                                </td>
                                                <td v-if="inEditMode">
                                                    <v-tooltip bottom>
                                                        <template v-slot:activator="{on, attrs}">
                                                            <v-btn
                                                                icon
                                                                v-bind="attrs"
                                                                @click="remove(row.item)"
                                                                v-on="on"
                                                            >
                                                                <v-icon small>fas fa-trash</v-icon>
                                                            </v-btn>
                                                        </template>
                                                        <span>{{ $t('tooltips.delete') }}</span>
                                                    </v-tooltip>
                                                </td>
                                            </tr>
                                        </template>
                                    </v-data-table>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </v-row>
        <v-row
            ><v-col>
                <v-dialog persistent v-model="showItemDialog" width="600">
                    <v-card>
                        <v-card-title>
                            {{ $t('labels.editItem') }}
                        </v-card-title>
                        <v-card-text>
                            <v-row>
                                <v-col cols="12">
                                    <v-row dense wrap>
                                        <v-col cols="12">
                                            <Dropdown
                                                :readonly="true"
                                                v-model="itemDialog.rank_id"
                                                :ajax="true"
                                                :data="'ranks-abbreviation'"
                                                :label="'* ' + $t('fields.rank')"
                                            ></Dropdown>
                                        </v-col>
                                        <v-col cols="12">
                                            <Dropdown
                                                v-model="itemDialog.seniority"
                                                :ajax="false"
                                                :data="seniorityList"
                                                :label="'* ' + $t('fields.seniority')"
                                            ></Dropdown>
                                        </v-col>
                                        <v-col cols="12">
                                            <CurrencyField
                                                :min="0"
                                                :max="10000"
                                                :readonly="!inEditMode"
                                                v-model="itemDialog.full"
                                                :label="$t('fields.fullDay')"
                                            ></CurrencyField>
                                        </v-col>
                                        <v-col cols="12">
                                            <CurrencyField
                                                :min="0"
                                                :max="10000"
                                                :readonly="!inEditMode"
                                                v-model="itemDialog.sick"
                                                :label="$t('fields.sickDay')"
                                            ></CurrencyField>
                                        </v-col>
                                        <v-col cols="12">
                                            <CurrencyField
                                                :min="0"
                                                :max="10000"
                                                :readonly="!inEditMode"
                                                v-model="itemDialog.travel"
                                                :label="$t('fields.travelDay')"
                                            ></CurrencyField>
                                        </v-col>
                                        <v-col cols="12">
                                            <CurrencyField
                                                :min="0"
                                                :max="10000"
                                                :readonly="!inEditMode"
                                                v-model="itemDialog.training"
                                                :label="$t('fields.trainingDay')"
                                            ></CurrencyField>
                                        </v-col>
                                        <v-col cols="12">
                                            <CurrencyField
                                                :min="0"
                                                :max="10000"
                                                :readonly="!inEditMode"
                                                v-model="itemDialog.quarantine"
                                                :label="$t('fields.quarantineDay')"
                                            ></CurrencyField>
                                        </v-col>
                                        <v-col cols="12">
                                            <CurrencyField
                                                :min="0"
                                                :max="10000"
                                                :readonly="!inEditMode"
                                                v-model="itemDialog.standby"
                                                :label="$t('fields.standbyDay')"
                                            ></CurrencyField>
                                        </v-col>
                                        <v-col cols="12">
                                            <CurrencyField
                                                :min="0"
                                                :max="10000"
                                                :readonly="!inEditMode"
                                                v-model="itemDialog.other"
                                                :label="$t('fields.otherDay')"
                                            ></CurrencyField>
                                        </v-col>
                                        <v-col cols="12">
                                            <CurrencyField
                                                v-if="wageTemplate.fee_type_id != 1"
                                                :min="0"
                                                :max="10000"
                                                :readonly="!inEditMode"
                                                v-model="itemDialog.fixed"
                                                :label="$t('fields.fixed')"
                                            ></CurrencyField>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="text-right"
                                            :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                        >
                                            <v-btn color="primary" class="white--text" @click.stop="updateItem"
                                                >{{ $t('buttons.save') }}
                                            </v-btn>
                                        </v-col>
                                        <v-col
                                            cols="12"
                                            md="6"
                                            class="text-left"
                                            :class="{'text-center': $vuetify.breakpoint.smAndDown}"
                                        >
                                            <v-btn color="secondary" class="white--text" @click.stop="closeDialog"
                                                >{{ $t('buttons.cancel') }}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-col></v-row
        >
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
import CheckBox from './trinkets/CheckBox';
import Dropdown from './trinkets/Dropdown';
import WageTemplate from '../models/WageTemplate';
import CurrencyField from '@/components/trinkets/CurrencyField';
import WageTemplateItem from '../models/WageTemplateItem';

export default {
    name: 'WageTemplate',
    components: {CheckBox, Dropdown, CurrencyField},
    data: function () {
        return {
            componentKey: 0,
            wageTemplate: new WageTemplate({}),
            wageTemplateValidation: new WageTemplate({}, true),
            initialLoad: false,
            lockKey: 'seafarer-wage-template',
            lockTimer: null,
            template_id: null,
            item: new WageTemplateItem({}),
            itemValidation: new WageTemplateItem({}, true),
            itemDialog: new WageTemplateItem({}),
            showItemDialog: false,
            items: [],
            itemHeaders: [
                {text: this.$t('fields.rank'), width: '10%'},
                {text: this.$t('fields.seniority'), width: '10%'},
                {text: this.$t('fields.fullDay'), width: '10%'},
                {text: this.$t('fields.sickDay'), width: '10%'},
                {text: this.$t('fields.travelDay'), width: '10%'},
                {text: this.$t('fields.trainingDay'), width: '10%'},
                {text: this.$t('fields.quarantineDay'), width: '10%'},
                {text: this.$t('fields.standbyDay'), width: '10%'},
                {text: this.$t('fields.otherDay'), width: '10%'},
                {text: this.$t('fields.fixedFee'), width: '10%'},
                {text: '', value: 'actions', type: '', sortable: false, width: '5%', allowFilter: false},
            ],
            seniorityList: [
                {value: 1, label: '1'},
                {value: 2, label: '2'},
                {value: 3, label: '3'},
                {value: 4, label: '4'},
                {value: 5, label: '5'},
                {value: 6, label: '6'},
                {value: 7, label: '7'},
                {value: 8, label: '8'},
                {value: 9, label: '9'},
                {value: 10, label: '10'},
            ],
            feeType: true,
            agencyFeePercentage: true,
            mergeSeafarerSalaryAndAgencyFeeOnOnvoice: true,
            fixedFee: true,
            dayReadonly: true,
        };
    },
    props: ['maritimeObject', 'inEditMode'],
    watch: {
        wageTemplate: {
            handler: function () {
                this.checkFieldsReadonly();
            },
            deep: true,
        },
    },

    methods: {
        updateItem() {
            let item = this.itemDialog;
            let vm = this;
            this.$APICall('post', 'wage-template-item/' + item.id, {item}, (data, succes) => {
                if (succes) {
                    vm.$alert(vm.$t('alerts.basicUpdate'));
                    vm.itemDialog = new WageTemplateItem({});
                    vm.showItemDialog = false;
                    vm.reloadItems();
                } else {
                    vm.$alert(vm.$t('alerts.basicError'));
                }
            });
        },
        closeDialog() {
            this.itemDialog = new WageTemplateItem({});
            this.showItemDialog = false;
        },
        edit(item) {
            let vm = this;
            this.$APICall('get', 'wage-template-item/' + item.id, {}, (data, succes) => {
                if (succes) {
                    vm.itemDialog = data;
                    this.showItemDialog = true;
                }
            });
        },
        editClick() {
            this.$emit('edit');
            this.$nextTick(() => {
                this.checkFieldsReadonly();
            });
        },
        remove(item) {
            let vm = this;
            let objectId = item.id;
            this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
                if (result) {
                    vm.$APICall('post', 'wage-template-items-remove/' + objectId, {}, (data, succes) => {
                        if (succes) {
                            vm.reloadItems();
                        } else {
                            vm.$alert(vm.$t('alerts.basicError'));
                        }
                    });
                }
            });
        },

        backClick() {
            this.$router.go(-1);
        },

        checkFieldsReadonly() {
            if (this.wageTemplate.apply_agency_fee == true) {
                if (this.inEditMode) {
                    this.feeType = true;
                }
            } else {
                this.feeType = false;
            }
            if (
                this.wageTemplate.salary_through_azara == true &&
                this.wageTemplate.apply_agency_fee == true &&
                this.wageTemplate.fee_type_id == 3
            ) {
                this.mergeSeafarerSalaryAndAgencyFeeOnOnvoice = true;
            } else {
                this.mergeSeafarerSalaryAndAgencyFeeOnOnvoice = false;
                this.wageTemplate.merge_seafarer_salary_and_agency_fee_on_invoice = false;
            }

            if (this.wageTemplate.fee_type_id == 1) {
                if (this.inEditMode) {
                    this.dayReadonly = false;
                } else {
                    this.dayReadonly = true;
                }
                this.agencyFeePercentage = true;
                this.fixedFee = false;
                this.item.fixed = 0;
                this.componentKey += 1;
            } else if (this.wageTemplate.fee_type_id == 2 || this.wageTemplate.fee_type_id == 3) {
                this.wageTemplate.agency_fee_percentage = null;
                this.agencyFeePercentage = false;
                this.dayReadonly = true;
                this.componentKey += 1;
                this.fixedFee = true;
            }
        },

        loadFromTemplate() {
            let vm = this;
            this.$verify(this.$t('alerts.loadTemplate'), (result) => {
                if (result) {
                    let maritimeObjectId = this.maritimeObject.id;
                    this.$APICall(
                        'post',
                        'wage-template-load/' + this.template_id,
                        {maritimeObjectId},
                        (data, success) => {
                            if (success) {
                                let usableData = JSON.parse(JSON.stringify(data));
                                vm.wageTemplate = usableData;
                                vm.reloadItems();
                            } else {
                                vm.$alert(vm.$t('alerts.basicError'));
                            }
                        },
                    );
                }
            });
        },

        saveItemClick() {
            let success = true;

            if (this.item.rank_id == null) {
                success = false;
                this.itemValidation.rank_id = false;
            } else {
                this.itemValidation.rank_id = true;
            }
            if (this.item.seniority == '') {
                success = false;
                this.itemValidation.seniority = false;
            } else {
                this.itemValidation.seniority = true;
            }
            let found = this.items.find(
                (element) => element.rank_id == this.item.rank_id && element.seniority == this.item.seniority,
            );
            if (success && !found) {
                this.item.wage_template_id = this.wageTemplate.id;
                if (this.wageTemplate.id == 0) {
                    this.$alert(this.$t('alerts.saveWageTemplateFirstToAddItems'));
                    this.items.push(this.item);
                    this.item = new WageTemplateItem({});
                    this.itemValidation = new WageTemplateItem({}, true);
                    this.componentKey += this.componentKey;
                } else {
                    let vm = this;
                    this.$APICall('post', 'wage-template-items/' + this.wageTemplate.id, this.item, (data, succes) => {
                        if (succes) {
                            vm.reloadItems();
                            vm.item = new WageTemplateItem({});
                            vm.itemValidation = new WageTemplateItem({}, true);
                            vm.componentKey += vm.componentKey;
                        }
                    });
                }
            } else if (found) {
                let vm = this;
                this.$alert(vm.$t('alerts.itemExists'));
            }
        },

        reloadItems() {
            let vm = this;
            this.$APICall('get', 'wage-template-items/' + this.wageTemplate.id, {}, (data, succes) => {
                if (succes) {
                    vm.items = data;
                }
            });
        },

        saveClick(goBack) {
            let success = true;
            let missingFields = '';

            if (this.wageTemplate.currency_id == null) {
                success = false;
                this.wageTemplateValidation.currency_id = false;
                missingFields += this.$t('fields.currency') + '<br/>';
            } else {
                this.wageTemplateValidation.currency_id = true;
            }

            if (this.wageTemplate.apply_agency_fee == true) {
                if (this.wageTemplate.fee_type_id == null) {
                    success = false;
                    this.wageTemplateValidation.fee_type_id = false;
                    missingFields += this.$t('fields.feeType') + '<br/>';
                } else if (this.wageTemplate.fee_type_id == 1) {
                    if (this.wageTemplate.agency_fee_percentage == '') {
                        success = false;
                        this.wageTemplateValidation.agency_fee_percentage = false;
                        missingFields += this.$t('fields.agencyFee') + '<br/>';
                    } else {
                        this.wageTemplateValidation.agency_fee_percentage = true;
                    }
                }
            } else {
                this.wageTemplateValidation.fee_type_id = true;
            }

            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.wageTemplate.id != 0) {
                    action = 'put';
                    addition = '/' + vm.wageTemplate.id;
                }

                this.$APICall(action, 'wage-templates' + addition, this.wageTemplate, (data, succes) => {
                    if (succes) {
                        vm.$APICall('get', 'wage-templates/' + this.maritimeObject.id, {}, (data, success) => {
                            if (success) {
                                let usableData = JSON.parse(JSON.stringify(data));
                                if (vm.wageTemplate.id != 0) {
                                    vm.$alert(vm.$t('alerts.basicUpdate'));
                                } else {
                                    vm.$alert(vm.$t('alerts.basicAdd'));
                                }
                                vm.wageTemplate = usableData;
                                if (goBack) {
                                    vm.backClick();
                                }
                            }
                        });
                        vm.$triggerReload();
                        vm.$emit('edit');
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                });
            } else {
                let alert = this.$t('alerts.missingFields') + '<br/> ' + missingFields;
                this.$alert(alert);
            }
        },
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        this.$APICall('get', 'wage-templates/' + this.maritimeObject.id, {}, (data, success) => {
            if (success) {
                let usableData = JSON.parse(JSON.stringify(data));
                vm.wageTemplate = usableData;
                this.componentKey += 1;
                vm.initialLoad = false;
                vm.checkFieldsReadonly();
                vm.reloadItems();
            } else {
                vm.initialLoad = true;
                vm.wageTemplate.maritime_object_id = vm.maritimeObject.id;
            }
        });
    },
};
</script>

<style scoped>
.v-data-table::v-deep th {
    font-size: 15px !important;
    font-weight: 900;
}
</style>
